import React, { useCallback, useMemo } from "react";
import Box from "@mui/material/Box";
import { ProductAttributesInput } from "../../../../../../components/filters/ProductAttributes/ProductAttributesInput";

interface ProductAttributesFilterProps {
  value: number[];
  onChange: (value: number[]) => void;
}

export const ProductAttributesFilter: React.FC<ProductAttributesFilterProps> =
  React.memo(({ value, onChange }) => {
    const selectedProductAttributes = useMemo(
      () => value.map((id) => id.toString()),
      [value]
    );

    const handleProductAttributesSelect = useCallback(
      (productAttributesIds: string[]) => {
        onChange(productAttributesIds.map(Number));
      },
      [onChange]
    );

    return (
      <Box id="install-product-attributes-filter" sx={{ mb: 1 }}>
        <ProductAttributesInput
          selectedItems={selectedProductAttributes}
          onProductAttributesSelect={handleProductAttributesSelect}
          id="install-product-attributes-input"
        />
      </Box>
    );
  });
